import React, { useEffect, useState } from "react";
import { Card, Spinner, Alert, Button } from "react-bootstrap";
import { getPlatformData } from "../../Api/PlatformAPI/index"; // adjust path
import "../../Assets/scss/components/PlatformInstallationGuidelines.scss";

interface PlatformData {
  id: number;
  name: string;
  short_description: string;
  slug: string;
  instruction_url: string | null;
  video_url: string | null;
}

interface Props {
  slug: string; // ✅ slug passed as prop
}

const PlatformInstallationGuidelines: React.FC<Props> = ({ slug }) => {
  const [platform, setPlatform] = useState<PlatformData | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>("");
  useEffect(() => {
    const fetchPlatform = async () => {
      try {
        setLoading(true);
        const res = await getPlatformData(slug);

        if (res?.status === 200) {
          if (res.data && res.data.length > 0) {
            setPlatform(res.data[0]);
          } else {
            setPlatform(null); // no guides, but not error
          }
        } else {
          setError(res?.msg || "Something went wrong");
        }
      } catch (err: any) {
        setError(err?.message || "Failed to load platform data");
      } finally {
        setLoading(false);
      }
    };

    if (slug) {
      fetchPlatform();
    }
  }, [slug]);

  //   console.log("platform", platform)
  if (loading) {
    return (
      <div className="text-center my-5">
        <Spinner animation="border" variant="primary" />
        <p>Loading installation guide...</p>
      </div>
    );
  }

  if (error) {
    return (
      <Alert variant="danger" className="my-4 text-center">
        {error}
      </Alert>
    );
  }

  if (!platform) return null;

  const hasGuides =
    Boolean(platform.instruction_url) || Boolean(platform.video_url);

  return (
    <div className="installation-guidelines container my-4 p-4">
      <h2 className="text-center">
        {platform.name} Installation Guidelines
      </h2>
      <Card className="guideline-card shadow-sm">
        <Card.Body>
          {platform.short_description && (
            <Card.Text
              className="test-align d-flex align-items-center justify-content-center"
              style={{ textAlign: "center" }}
            >
              {platform?.short_description}
            </Card.Text>
          )}

          {hasGuides ? (
            <div className="d-flex flex-column flex-md-row gap-3 mt-3">
              {platform?.instruction_url && (
                <Button
                  variant="primary"
                  className="guideline-btn flex-fill"
                  onClick={() =>
                    window.open(platform.instruction_url!, "_blank")
                  }
                >
                  📖 Read Instructions
                </Button>
              )}

              {platform?.video_url && (
                <Button
                  variant="outline-primary"
                  className="guideline-btn flex-fill"
                  onClick={() => window.open(platform.video_url!, "_blank")}
                >
                  🎥 Watch Video
                </Button>
              )}
            </div>
          ) : (
            <Alert variant="info" className="mt-3 text-center">
              No guides available yet for this platform.
            </Alert>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default PlatformInstallationGuidelines;
